import React, {useState} from "react";
import ActionButton from "../../components/ActionButton";
import {getLastElementOr, renderlog, showlog} from "../../utils";
import {deleteVersion, getAllVersions, getVersion, saveVersion} from "./version";
import {SwitchComponent} from "../../components/switch-component/switch-component";
import './version-page.css';
import {extractErrorMessage} from "../../utils/string-utils";
import {AlertPanel} from "../../components/alert/alert-panel";


type VersionType = {
    version: string;
    changes: string;
};


export const VersionPage = props => {

    const [versions, setAllVersions]        = useState<VersionType[]>();
    const [selectedVersion, selectVersion]  = useState<VersionType>();
    const [lastVersion, setLastVersion]     = useState<VersionType>();
    const [newVersion, setNewVersion]       = useState<string>( !!lastVersion ? lastVersion.version : '' );
    const [changeLog, setChangeLog]         = useState<string>( !!lastVersion ? lastVersion.changes : '' );
    const [important, isImportant]          = useState<boolean>();
    const [isNewVersion, setIsNewVersion]   = useState<boolean>();
    const [error, setError]                 = useState();

    if( !lastVersion && !error) {
        // getVersion()
        //     .then( v => {
        //         debugger;
        //         setLastVersion( v );
        //         selectVersion( v );
        //     })
        //     .catch( e => {
        //         showlog('errore', e);
        //         debugger;
        //         setError( e );
        //     })
        // ;
        //
        getAllVersions()
            .then( vs => {

                if( vs.length === 0 ) {
                    setLastVersion({ version: 'N', changes: 'Non ci sono versioni ancora'})
                }
                else {
                    setAllVersions( vs );
                    setLastVersion( vs.reduce( getLastElementOr, undefined ) );
                    selectVersion( vs.reduce( getLastElementOr, undefined ) );
                }
            })
            .catch( e => {
                showlog('errore 2', e);
                debugger;
                setError( e );
            })
        ;
    }

    renderlog("VersionPage", {versions, selectedVersion, lastVersion, newVersion, changeLog, important, isNewVersion, error}, props);

    return (

        <div className={"version-page"}>
            <div>
                <ActionButton
                    action={ () => Promise.resolve() }
                    onResult={ () => {
                        setIsNewVersion( true );
                        selectVersion( undefined );
                    }}
                    buttonText={'Nuova Versione'}
                    className={'new-version-button'}
                />
                {
                    (!!versions && (versions instanceof Array) /*&& !!selectedVersion*/ )
                        ? (
                            versions
                                .map( (v: any) => (
                                    <div
                                        className={`historical-version ${ (!!selectedVersion && (v.version === selectedVersion.version)) ? "version-active" : ""}`}
                                        onClick={ clickEvent => {
                                            setIsNewVersion( false )
                                            selectVersion( v );
                                        }}
                                    >
                                        <div>
                                            {
                                                !!v.important
                                                    ? (
                                                        <img
                                                            className={`important-update`}
                                                            src={'/imgs/golden_star.png'}
                                                        />
                                                    )
                                                    : (
                                                        <div
                                                            className={`important-update`}
                                                        />
                                                    )
                                            }
                                            <span>{ v.version }</span>
                                        </div>

                                        <img
                                            src={'/imgs/delete.png'}
                                            className={`trash`}
                                            onClick={ clickEvent => {
                                                let response = window.confirm(`Sicuro di eliminare la versione ${ v.version }?`);

                                                if( !!response ) {
                                                    deleteVersion( v.id )
                                                        .then( result => {
                                                            getAllVersions()
                                                                .then( vs => {
                                                                    setAllVersions( vs );
                                                                    setLastVersion( vs[0] );
                                                                    // selectVersion( vs[0] );
                                                                })
                                                                .catch( e => {
                                                                    setError( e );
                                                                })
                                                            ;
                                                        })
                                                        .catch( e => {
                                                            setError( e );
                                                        })
                                                }


                                                ;
                                            }}
                                        />
                                    </div>
                                ))
                        )
                        : null
                }
            </div>
            <div className={"version-page-details"}>

                {
                    !!selectedVersion
                        ? (
                            <div>
                                <h4>{ selectedVersion.version }</h4>
                                <code>Date Time</code>
                                <div className={"version-page-details-changes"}>
                                    {
                                        !!selectedVersion
                                            ? selectedVersion.changes
                                            : null
                                    }
                                </div>
                            </div>
                        )
                        : (
                            !!isNewVersion
                                ? (
                                    <div>
                                        <em className={"warning-disclaimer"} style={{ visibility: (!!newVersion ? "visible" : "hidden") }}>
                                            ATTENZIONE!<br/>
                                            al salvataggio di una nuova versione verrà notificato a tutti gli operatori che hanno una versione diversa da quella indicata
                                        </em>
                                        <div className={"version-panel"}>

                                            <div>
                                                <span>Nome Versione</span>
                                                <code>Ultima versione { !!lastVersion ? lastVersion.version : null }</code>
                                                <input
                                                    type={"text"}
                                                    name={"version"}
                                                    id={"version"}
                                                    onChange={ changeEvent => {
                                                        setNewVersion( changeEvent.target.value );
                                                        setError( undefined );
                                                    }}
                                                    placeholder={
                                                        !!lastVersion
                                                            ? lastVersion.version
                                                            : undefined
                                                    }
                                                    value={ newVersion }
                                                />

                                                <div className={'important-container'}>
                                                    <label>importante</label>
                                                    <SwitchComponent
                                                        active={ !!important }
                                                        onToggle={(newValue: boolean) => {
                                                            // document.getElementById( "isImportant" ).checked = !important;
                                                            isImportant( !!newValue );
                                                        }}
                                                    />
                                                </div>

                                            </div>


                                            <div>

                                                <label>ChangeLog</label>
                                                <textarea
                                                    name={"changeLog"}
                                                    id={"changeLog"}
                                                    onChange={ changeEvent => {
                                                        setChangeLog( changeEvent.target.value );
                                                    }}
                                                    placeholder={
                                                        !!lastVersion
                                                            ? lastVersion.changes
                                                            : undefined
                                                    }
                                                    value={ changeLog }
                                                />

                                                <ActionButton
                                                    promise={ () => {
                                                        return (
                                                            // @ts-ignore
                                                            saveVersion(document.getElementById("version").value, !!important, changeLog)
                                                                .then( response => {

                                                                    return (
                                                                        getVersion()
                                                                            .then( v => {
                                                                                return v;
                                                                            })
                                                                            .catch( e => {
                                                                                return Promise.reject( e );
                                                                            })
                                                                    );

                                                                })
                                                                .catch( e => {
                                                                    return Promise.reject( e );
                                                                })
                                                        );
                                                    } }
                                                    onResult={ p => {
                                                        showlog("last version");
                                                        showlog( p );
                                                        setLastVersion( p );
                                                        setChangeLog( "");
                                                        isImportant( false );
                                                        setNewVersion("");
                                                        selectVersion( p );
                                                        getAllVersions()
                                                            .then( vs => {
                                                                setAllVersions( vs );
                                                            })
                                                            .catch( e => {
                                                                setError( e );
                                                            })
                                                        ;
                                                    }}
                                                    onError={ e => {
                                                        showlog("errore al salvataggio");
                                                        showlog( e );
                                                        setError( e );
                                                    }}
                                                    disabled={ !newVersion }
                                                    waitingText={"wait"}
                                                    className={"save-button"}
                                                    buttonText={'Salva'}
                                                />
                                            </div>

                                            {
                                                !!error
                                                    ? (
                                                        <AlertPanel
                                                            content={ extractErrorMessage(error) }
                                                            onClose={() => {
                                                                setError( undefined )
                                                            }}
                                                            level={ 'ERROR' }
                                                            // className={"error-label"}
                                                        />
                                                    )
                                                    : null
                                            }
                                        </div>
                                    </div>
                                )
                                : null
                        )
                }

            </div>
        </div>

    );
}
